import { Box, IconButton, Tooltip, Fab, Typography } from "@mui/material"
import { useState } from "react"
import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"
import SaveIcon from "@mui/icons-material/Save"
import { IDataDetalheFluxo } from "../../../../../types/api/configuracoes/detalhar-fluxo";
import { useForm, FormProvider } from "react-hook-form";
import FormConfiguracoes from "./FormConfiguracoes";
import { IMutationAtualizarFluxo } from "../../../../../types/mutations/bpm/atualizar-fluxo"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function SideBar({
    infoFluxo,
    onSalvarConfiguracoes,
    isLoading
}: ISideBarProps) {
    const [isVisible, setIsVisible] = useState(true);

    const methods = useForm<FormConfigFluxo>({
        defaultValues: {
            identificador: infoFluxo.identificador,
            nome: infoFluxo.nome,
            versao: infoFluxo.versao,
            status: infoFluxo.status,
            perfil_solicitante: infoFluxo.perfil_solicitante,
            sem_perfil_solicitante: !Boolean(infoFluxo.perfil_solicitante),
            bloquear_anexo_processo: !Boolean(infoFluxo.bloqueia_anexo_tarefa),
            bloquear_anexo_tarefas: infoFluxo.bloqueia_anexo_tarefa?.map(String) || [],
            possui_data_expiracao: infoFluxo.possui_data_expiracao,
            dias_expiracao: infoFluxo.dias_expiracao,
            modulo: infoFluxo.modulo
        }
    });

    const onSubmit = (data: FormConfigFluxo) => {
        onSalvarConfiguracoes({
            id: infoFluxo.identificador,
            nome: data.nome,
            status: data.status,
            perfil_solicitante_id: data.sem_perfil_solicitante ? null : data.perfil_solicitante?.id || null,
            bloqueia_anexo_tarefa: data.bloquear_anexo_processo ? null : data.bloquear_anexo_tarefas.map(Number),
            spec: JSON.stringify(infoFluxo.spec),
            possui_data_expiracao: data.possui_data_expiracao,
            dias_expiracao: Number(data.dias_expiracao),
            modulo: data.modulo
        });
    };

    const toggleSidebar = () => {
        setIsVisible(!isVisible);
    };

    return (
        <>
            <Box
                position="fixed"
                left={isVisible ? 420 : 10}
                top={100}
                zIndex={1001}
                sx={{
                    transition: "0.2s"
                }}
            >
                <Tooltip title={isVisible ? "Ocultar menu" : "Mostrar menu"}>
                    <IconButton
                        onClick={toggleSidebar}
                        sx={{
                            bgcolor: "white",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                            "&:hover": {
                                bgcolor: "#f5f5f5"
                            }
                        }}
                    >
                        {isVisible ? <CloseIcon /> : <MenuIcon />}
                    </IconButton>
                </Tooltip>
            </Box>

            <Box
                position="fixed"
                display="flex"
                width={400}
                height="calc(100vh - 110px)"
                bgcolor="white"
                borderRadius={2}
                border="1px solid rgba(0,0,0,0.2)"
                sx={{
                    left: isVisible ? 10 : -420,
                    top: 90,
                    transform: "none",
                    transition: "0.2s",
                    boxShadow: "2px 0px 10px -3px rgba(0,0,0,0.2)",
                    zIndex: 1000
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        width: "100%",
                        height: "100%",
                        overflowY: "auto",
                        gap: 2,
                        padding: 2
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <IconButton size="small" onClick={() => window.history.back()}>
                            <ArrowBackIcon fontSize="inherit" />
                        </IconButton>

                        <Typography variant="subtitle1">
                            Detalhe do fluxo
                        </Typography>
                    </Box>

                    <FormProvider {...methods}>
                        <FormConfiguracoes
                            tarefas={infoFluxo.spec.nodes
                                .slice(1, -1)
                                .map(node => ({
                                    id: node.id,
                                    titulo: node.data.titulo
                                }))}
                        />
                    </FormProvider>
                </Box>
            </Box>

            <Fab
                onClick={methods.handleSubmit(onSubmit)}
                color="primary"
                disabled={isLoading}
                style={{
                    margin: 0,
                    top: 'auto',
                    right: 20,
                    bottom: 20,
                    left: 'auto',
                    position: 'fixed',
                    zIndex: 1200
                }}
            >
                <SaveIcon />
            </Fab>
        </>
    )
}

interface ISideBarProps {
    isLoading: boolean;
    infoFluxo: IDataDetalheFluxo
    onSalvarConfiguracoes: (data: IMutationAtualizarFluxo) => void
}

export interface FormConfigFluxo {
    identificador: string;
    nome: string;
    versao: number;
    status: string;
    perfil_solicitante: {
        id: number;
        nome: string;
    } | null;
    sem_perfil_solicitante: boolean;
    bloquear_anexo_processo: boolean;
    bloquear_anexo_tarefas: string[];
    possui_data_expiracao: boolean;
    dias_expiracao: number | null;
    modulo: string | null;
}
